
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/pages/utils/components/newWorkspaceContentHeader.scss.css.virtualfile';
        module.exports = {"root":"_root_9a091_8","addPage":"_addPage_9a091_16"};